import { ClientError } from 'graphql-request'
import { AlertLevel, IconAlert } from '@shared/components/icon-alert/icon-alert'
import { CRMErrors } from '@/pages/stations/details/station-details.page'

export interface CRMErrorAlertsProps {
  crmError: ClientError | null
  notFoundIsError?: boolean
}

export function CRMErrorAlerts({ crmError, notFoundIsError = true }: CRMErrorAlertsProps) {
  // The error object from the useQuery has the full response object attached to it
  // though it is typed as an Error. Throwing an exception from the GraphQL handler on the server
  // results in a 200 response with a list of errors in the response object.
  const firstError = crmError?.response?.errors?.[0]

  const crmErrorCode = (): string => (firstError?.extensions?.code as string) ?? ''

  const crmErrorMessage = (): string => firstError?.message ?? ''

  return (
    <>
      {crmError && crmErrorCode() === CRMErrors.NotFound && (
        <IconAlert
          level={notFoundIsError ? AlertLevel.ERROR : AlertLevel.WARNING}
          title='CRM information not found'
          message={crmErrorMessage()}
        />
      )}
      {crmError && crmErrorCode() === CRMErrors.Ambiguous && (
        <IconAlert
          level={AlertLevel.ERROR}
          title='CRM information ambiguous'
          message={crmErrorMessage()}
        />
      )}
      {crmError && !Object.keys(CRMErrors).includes(crmErrorCode()) && (
        <IconAlert
          level={AlertLevel.ERROR}
          title='CRM request failed'
          message={crmErrorMessage()}
        />
      )}
    </>
  )
}
